import { render, staticRenderFns } from "./code2.vue?vue&type=template&id=a60e32ec&scoped=true&"
import script from "./code2.vue?vue&type=script&lang=js&"
export * from "./code2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60e32ec",
  null
  
)

export default component.exports